import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as authApi from "services/data.auth.service";

const AuthContext = React.createContext();

export const getUserFromLocalStorage = () => JSON.parse(localStorage.getItem("userData"));
export const setUserToLocalStorage = (obj) => localStorage.setItem("userData", JSON.stringify(obj));
const clearUserLocalStorage = () => localStorage.removeItem("userData");
export const getCustomersFromLocalStorage = () => JSON.parse(localStorage.getItem("customers"));
export const setCustomersToLocalStorage = (obj) => localStorage.setItem("customers", JSON.stringify(obj));
const clearCustomersLocalStorage = () => localStorage.removeItem("customers");
export const getCustomerFromLocalStorage = () => JSON.parse(localStorage.getItem("customer"));
export const setCustomerToLocalStorage = (obj) => localStorage.setItem("customer", JSON.stringify(obj));
const clearCustomerLocalStorage = () => localStorage.removeItem("customer");
export const getTeamsFromLocalStorage = () => JSON.parse(localStorage.getItem("teams"));
export const setTeamsToLocalStorage = (obj) => localStorage.setItem("teams", JSON.stringify(obj));
const clearTeamsLocalStorage = () => localStorage.removeItem("teams");
export const getPermissionsFromLocalStorage = () => JSON.parse(localStorage.getItem("permissions"));
export const setPermissionsToLocalStorage = (obj) => localStorage.setItem("permissions", JSON.stringify(obj));
const clearPermissionsLocalStorage = () => localStorage.removeItem("permissions");
export const getTeamsCrossDBFromLocalStorage = () => JSON.parse(localStorage.getItem("teams"));
export const setTeamsCrossDBToLocalStorage = (obj) => localStorage.setItem("teams", JSON.stringify(obj));
const clearTeamsCrossDBLocalStorage = () => localStorage.removeItem("teams");

export function useAuth() {
  return useContext(AuthContext);
}
export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const location=useLocation()
  const{pathname}=location
  const path=pathname.split("/")
  let pathName2=path[2]
  const [user, setUser] = useState(null);
  const [customers,setCustomers]=useState([])
  const [customer,setCustomer]=useState("")

  //team name
  const [teams,setTeams]=useState([])
  const [permissions, setPermissions] = useState([]);
  const [teamsCrossDB,setTeamsCrossDB]=useState([])
  const [triggerPermission, setTriggerPermission]=useState(false);
  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };

  const login = async (userName, password) => {
    const resp = await authApi.login(userName, password);
    setUserToLocalStorage(resp.data.userData);
    setUser(resp.data.userData);
    setCustomersToLocalStorage(resp.data.customers)
    setCustomers(resp.data.customers)
    setCustomerToLocalStorage(resp.data.lastCustomer)
    setCustomer(resp.data.lastCustomer)
    setTeamsToLocalStorage(Boolean(resp.data.teams) ? resp.data.teams : [])
    setTeams(Boolean(resp.data.teams) ? resp.data.teams : [])
    setPermissionsToLocalStorage(Boolean(resp.data.webPermissions) ? resp.data.webPermissions : [])
    setPermissions(Boolean(resp.data.webPermissions) ? resp.data.webPermissions : [])
    setTeamsCrossDBToLocalStorage(Boolean(resp.data.teamsCrossDB) ? resp.data.teamsCrossDB : [])
    setTeamsCrossDB(Boolean(resp.data.teamsCrossDB) ? resp.data.teamsCrossDB : [])
    setTriggerPermission(true);
    return resp.data;
  };

  const switchCustomer = async (customerCode) =>{
    if(user){
      const resp = await authApi.logout({userId:user?.userId,customerCode})
      if(resp.data.statusCode === 200){
        setCustomerToLocalStorage(customerCode)
        setCustomer(customerCode)
        setTriggerPermission(true)
      }
      return resp.data.statusCode
    }
    return 400
  }

  useEffect(() => {
    async function fetchPermission() {
      const customers = getCustomersFromLocalStorage();
    const customer = getCustomerFromLocalStorage()
    const teamsCrossDB = getTeamsCrossDBFromLocalStorage();
    const permission = getPermissionsFromLocalStorage();
    const custDb = Boolean(customers) ? customers.find(c => c.customerCode === customer) : null;
    if (custDb){
      const dbKey = custDb.dataKey;
      const teamsInDB = teamsCrossDB.filter(x => x.dataKey === dbKey).map(x => x.teamName);
      const admin = (Boolean(permission["Team Role"]) && permission["Team Role"].some(a => a === "access"));
      const resp = await authApi.permission({teams: teamsInDB,admin: admin})
      if (resp.data.code === 200){
        setPermissionsToLocalStorage(Boolean(resp.data.data.webPermissions) ? resp.data.data.webPermissions : [])
        setPermissions(Boolean(resp.data.data.webPermissions) ? resp.data.data.webPermissions : [])
      }
    }
    setTriggerPermission(false);
    if (path[1])
    navigate(`/${path[1]}/${pathName2}`)
  else navigate("/")
    }

    if (triggerPermission) fetchPermission();
  }, [customer]);

  // const refreshToken = async () => {
  //   //await authApi.logout(userName);
  //   if(user){
  //     const resp = await authApi.refreshToken(user?.refreshToken)
  //     const data = resp.data
  //     if(data){
  //       const {jwtToken,refreshToken}=data
  //       setUser({...user,jwtToken,refreshToken})
  //     }
  //   }
  // };

  const logout = async () => {
    //await authApi.logout(userName);
    if(user){
      const resp = await authApi.logout({userId:user?.userId})
      if(resp.data.statusCode === 200){
        clearUserLocalStorage();
        clearCustomersLocalStorage()
        clearCustomerLocalStorage()
        setUser(null);
        setCustomers([])
        setCustomer("")
        setTeams([]);
        clearTeamsLocalStorage()
        clearPermissionsLocalStorage()
        setPermissions([])
        clearTeamsCrossDBLocalStorage()
        setTeamsCrossDB([])
      }
    }
  };

  useEffect(() => {
    //Check token validity
    //let authInfo = localStorage.getItem("auth");
    const userData = getUserFromLocalStorage();
    const customers = getCustomersFromLocalStorage();
    const customer = getCustomerFromLocalStorage()
    const teams = getTeamsFromLocalStorage();
    const permission = getPermissionsFromLocalStorage();
    const teamsCrossDB = getTeamsCrossDBFromLocalStorage();
    if (userData) {
      setUser(userData);
      setCustomers(customers)
      setCustomer(customer)
      setTeams(teams);
      setPermissions(permission);
      setTeamsCrossDB(teamsCrossDB);
    }

    /*const timerId = setInterval(() => {
      authApi
        .sessionCheck()
        //.then((resp) => console.log(resp))
        .catch((err) => {
          if (err.response.status === 401) {
            clearUserLocalStorage();
            setUser(null);
          }
        });
    }, 5000);

    //Unsubscribe
    /*return () => {
      clearInterval(timerId);
    };*/
  }, []);

  // useEffect(() => {
  //   if (user) {
  //     const decodedJwt = parseJwt(user.jwtToken);
  //     const timerId = setInterval(() => {
  //       refreshToken()
  //     }, 30000);

  //     //Unsubscribe
  //     return () => {
  //       clearInterval(timerId);
  //     };
  //   }
  //   return () => {};
  // }, [user]);

  useEffect(() => {
    if (user) {
      const decodedJwt = parseJwt(user.jwtToken);
      const timerId = setInterval(() => {
        if (decodedJwt.exp * 1000 < Date.now()) {
          logout();
        }
      }, 5000);

      //Unsubscribe
      return () => {
        clearInterval(timerId);
      };
    }
    return () => {};
  }, [user]);

  const value = useMemo(() => {
    return {
      user,
      customers,
      customer,
      switchCustomer,
      login,
      logout,
      getUserFromLocalStorage,
      teams,
      permissions,
      teamsCrossDB,
    };
  }, [user,customers,customer,switchCustomer, login, logout, teams, permissions, teamsCrossDB]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
